import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../lib/api-client";
import { queryKeys } from "../query-keys";
import {
  UpdateProfileResponseSchema,
  type UpdateProfile,
} from "@applicant-reviewer/api";

export function useUpdateProfile() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: UpdateProfile) =>
      apiClient.put("/candidate/profile", UpdateProfileResponseSchema, data),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.profile.data() }),
  });
}
